import React from 'react';

import { SearchBar } from '@metarouter-private/mr-mui';

import { useBulkPlaybookUpdateTableContext } from 'ion-experimental/app/bulk-playbook-update/BulkPlaybookUpdateTableContext';

export default function BulkPlaybookUpdateSearchBar() {
  const { searchTerm, setSearchTerm } = useBulkPlaybookUpdateTableContext();

  return (
    <SearchBar
      variant="outlined"
      placeholder="Filter by Name or Writekey..."
      size="small"
      value={searchTerm}
      onChange={event => setSearchTerm(event.target.value)}
      data-test-id="bulkPlaybookUpdateSearchBar"
    />
  );
}
